import { useEffect } from 'react';

interface ConversionPixelProps {
  conversionId?: string;
  conversionLabel?: string;
  value?: number;
  currency?: string;
}

const ConversionPixel: React.FC<ConversionPixelProps> = ({
  conversionId,
  conversionLabel,
  value,
  currency = 'USD'
}) => {
  useEffect(() => {
    if (!conversionId || !conversionLabel) return;

    // Google Ads Conversion Tracking
    const gtagConversionScript = `
      gtag('event', 'conversion', {
        'send_to': '${conversionId}/${conversionLabel}',
        'value': ${value || 0},
        'currency': '${currency}',
        'transaction_id': '${Date.now()}_${Math.random().toString(36).substr(2, 9)}'
      });
    `;

    // Execute the conversion tracking
    if (typeof window !== 'undefined' && window.gtag) {
      try {
        eval(gtagConversionScript);
      } catch (error) {
        console.error('Conversion tracking error:', error);
      }
    }

    // Facebook Pixel Conversion
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Lead', {
        value: value || 0,
        currency: currency,
        content_name: conversionLabel
      });
    }
  }, [conversionId, conversionLabel, value, currency]);

  return null; // This component doesn't render anything
};

// Predefined conversion pixels for common actions
export const QuoteRequestPixel = () => (
  <ConversionPixel 
    conversionId="AW-XXXXXXXXX" 
    conversionLabel="quote_request"
    value={500}
  />
);

export const ContactFormPixel = () => (
  <ConversionPixel 
    conversionId="AW-XXXXXXXXX" 
    conversionLabel="contact_form"
    value={300}
  />
);

export const ROICalculatorPixel = () => (
  <ConversionPixel 
    conversionId="AW-XXXXXXXXX" 
    conversionLabel="roi_calculator"
    value={200}
  />
);

export const NewsletterSignupPixel = () => (
  <ConversionPixel 
    conversionId="AW-XXXXXXXXX" 
    conversionLabel="newsletter_signup"
    value={50}
  />
);

export const PhoneCallPixel = () => (
  <ConversionPixel 
    conversionId="AW-XXXXXXXXX" 
    conversionLabel="phone_call"
    value={400}
  />
);

export default ConversionPixel;